import dev from './dev';
import prod from './prod';

const config = prod;

export default config;
